import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Users, Clock, DollarSign } from 'react-feather';

const NotificationPopup = ({ show, onClose }) => {
  if (!show) return null;

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1050
      }}
    >
     <div style={{
  background: 'linear-gradient(135deg, #283593, #1e88e5)',
  borderRadius: '12px',
  padding: '30px',
  width: '600px',
  textAlign: 'center',
  color: '#ffffff',
  boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
  position: 'relative'
}}>
  {/* Close Button */}
  <button  onClick={onClose} style={{
    position: 'absolute',
    top: '15px',
    right: '15px',
    background: 'transparent',
    border: 'none',
    color: '#ffffff',
    fontSize: '20px',
    cursor: 'pointer'
  }}>
    ×
  </button>

  {/* Logo */}
  <img src="https://netshine-assets.blr1.cdn.digitaloceanspaces.com/web-assets/logo-dark.png" alt="Netshine Office" style={{
    width: '250px',
    marginBottom: '20px'
  }} />

<h2 style={{
  fontSize: '30px',
  fontWeight: 'bold',
  marginBottom: '30px',
  color: '#ffffff',
  textShadow: '0 1px 3px rgba(0,0,0,0.5)'
}}>
  Unlock the Power of NetShine Platform
</h2>

<p style={{
  fontSize: '16px',
  lineHeight: '1.5',
  marginBottom: '25px',
  color: '#e0e7ff'
}}>
  You're trying to access a premium feature. Subscribe now to unlock full access and supercharge your business with real-time tools, streamlined operations, and intelligent automation.
</p>


  {/* Subscribe Button */}
  <button style={{
    backgroundColor: '#00e676',
    color: '#000000',
    fontWeight: 'bold',
    padding: '12px 25px',
    borderRadius: '25px',
    border: 'none',
    cursor: 'pointer',
    fontSize: '16px',
    transition: 'background 0.3s ease'
  }}
    onMouseOver={e => e.target.style.backgroundColor = '#00c853'}
    onMouseOut={e => e.target.style.backgroundColor = '#00e676'}
  >
    Subscribe Now
  </button>
</div>

    </div>
  );
};

export default NotificationPopup;